module.exports = __webpack_public_path__ + "img/image_ot-panama-coassa-colon_tanks1_1920px.a81a5f42.jpg";